"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FalconNavigatorHeader = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = __importStar(require("react"));
const PluginTemplates_1 = require("./PluginTemplates");
const index_1 = require("../index");
class FalconNavigatorHeader extends React.Component {
    constructor() {
        super(...arguments);
        this.defaultBackButtonLabel = "Back";
        this.pluginTemplates = new PluginTemplates_1.PluginTemplates();
    }
    render() {
        return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [this.renderBack(), this.renderTitle(), this.props.children] });
    }
    renderTitle() {
        if (!this.props.title) {
            return undefined;
        }
        if (typeof this.props.title === "string") {
            return this.renderStringTitle(this.props.title);
        }
        return this.renderObjectTitle(this.props.title);
    }
    splitTitle(title) {
        var _a;
        if (!title || typeof title !== "string") {
            return "";
        }
        const words = title.trim().split(/\s+/);
        const renderTitleColor = (fromIndex) => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [words.slice(0, fromIndex).join(" "), " ", (0, jsx_runtime_1.jsx)("span", { className: "last-word", children: words.slice(fromIndex).join(" ") })] }));
        const titleHighlightMap = {
            "Britannia Car Insurance": 2,
            "Your car, make changes": 2,
            "Here's your summary": 1,
            "Price to pay": 1,
            "please log in to your account": 6,
            "Edit car details": 1,
            "Driving licence details for additional driver": 2,
            "Personal details for additional driver": 2,
            "Claims for additional driver": 2
        };
        if (/^Edit driver/i.test(title)) {
            return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [words[0], " ", (0, jsx_runtime_1.jsx)("span", { className: "last-word", children: words[1] }), " ", words.slice(2).join(" ")] }));
        }
        const wordsToHighlight = (_a = titleHighlightMap[title.trim()]) !== null && _a !== void 0 ? _a : 1;
        const highlightFromIndex = words.length - wordsToHighlight;
        return renderTitleColor(highlightFromIndex);
    }
    renderBack() {
        if (!this.props.back) {
            return undefined;
        }
        switch (typeof this.props.back) {
            case "string":
                return this.renderStringBack(this.props.back);
            default:
                return this.renderObjectBack(this.props.back);
        }
    }
    renderStringTitle(title) {
        if (!title) {
            return undefined;
        }
        if (index_1.resourcesHelper.THEME === "Britannia") {
            return ((0, jsx_runtime_1.jsx)("div", { className: "text-group title plugin no-indent-desktop", children: (0, jsx_runtime_1.jsx)("h1", { className: this.props.children ? "mb-2" : "m-0", children: this.splitTitle(title) }) }));
        }
        return ((0, jsx_runtime_1.jsx)("div", { className: "text-group title plugin no-indent-desktop", children: (0, jsx_runtime_1.jsx)("h1", { className: this.props.children ? "mb-2" : "m-0", children: title }) }));
    }
    renderObjectTitle(titleProps) {
        if (titleProps.hidden || (!titleProps.label && !titleProps.html)) {
            return undefined;
        }
        if (titleProps.html) {
            return titleProps.html;
        }
        const label = Array.isArray(titleProps.label)
            ? titleProps.label[0]
            : titleProps.label;
        return this.renderStringTitle(label);
    }
    renderStringBack(link) {
        return this.pluginTemplates.renderBackLink(this.defaultBackButtonLabel, true, link);
    }
    renderObjectBack(backProps) {
        var _a;
        if (backProps.hidden || (!backProps.link && !backProps.html && !backProps.action)) {
            return undefined;
        }
        if (backProps.html) {
            return backProps.html;
        }
        if (!backProps.action) {
            return this
                .pluginTemplates
                .renderBackLink((_a = backProps.label) !== null && _a !== void 0 ? _a : this.defaultBackButtonLabel, true, backProps.link);
        }
        else {
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)("div", { className: "back-link-top", children: (0, jsx_runtime_1.jsx)("a", { onClick: this.pluginTemplates.goBack, children: (0, jsx_runtime_1.jsx)("button", { type: "button", role: "link", className: `btn btn-back-link`, onClick: backProps.action, children: "Back" }) }) }) });
        }
    }
}
exports.FalconNavigatorHeader = FalconNavigatorHeader;
//# sourceMappingURL=FalconNavigatorHeader.js.map